import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/API';

export const getDownloads = createAsyncThunk(
  'download',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get('/downloads');

      if (response.status === 200) {
        return response?.data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
